import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ImageModule } from 'primeng/image';
import { MessageService } from 'primeng/api';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { ProductModel } from '../../../../model/product.model';
import { ProductCategoryModel } from '../../../../model/product-category.model';

@Component({
  selector: 'app-list-product',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    ButtonModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    TagModule,
    ToastModule,
    ImageModule,
  ],
  providers: [MessageService],
  templateUrl: './list-product.component.html',
  styleUrl: './list-product.component.css',
})
export class ListProductComponent implements OnInit {
  @Input() storeId: number = 0;
  ltsProducts: ProductModel[] = [];
  ltsCategories: ProductCategoryModel[] = [];
  categoryFilterOptions: any[] = [];
  loading: boolean = false;
  selectedCategoryFilter: number | null = null;
  searchText: string = '';

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.loadProducts();
    this.loadCategories();
  }

  loadProducts(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        pro_store_id: this.storeId,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.loading = true;
    this.apiService.consumirWSPost(
      properties.serviceGetProductsByStore,
      body,
      (data) => {
        this.ltsProducts = data.data ?? [];
        this.loading = false;
      },
    );
  }

  loadCategories(): void {
    this.apiService.consumirWSGet(
      properties.serviceGetAllProductCategories,
      null,
      (data) => {
        this.ltsCategories = data.data ?? [];
        this.categoryFilterOptions = [
          { label: 'Todas', value: null },
          ...this.ltsCategories.map((c) => ({ label: c.pca_name, value: c.pca_id })),
        ];
      },
    );
  }

  get filteredProducts(): ProductModel[] {
    return this.ltsProducts.filter((product) => {
      const matchesCategory =
        this.selectedCategoryFilter === null ||
        this.selectedCategoryFilter === undefined ||
        product.pro_category_id === this.selectedCategoryFilter;

      const matchesSearch =
        this.searchText === '' ||
        product.pro_name
          .toLowerCase()
          .includes(this.searchText.toLowerCase());

      return matchesCategory && matchesSearch;
    });
  }

  toggleAvailability(product: ProductModel): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        pro_id: product.pro_id,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };

    this.apiService.consumirWSPost(
      properties.serviceChangeAvailabilityProduct,
      body,
      (data) => {
        if (data.estado === properties.codeOK) {
          const idx = this.ltsProducts.findIndex(
            (p) => p.pro_id === product.pro_id
          );
          if (idx >= 0) {
            this.ltsProducts[idx].pro_is_available =
              !this.ltsProducts[idx].pro_is_available;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Estado de disponibilidad actualizado',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al actualizar disponibilidad',
          });
        }
      },
    );
  }

  getCategoryName(categoryId: number): string {
    const category = this.ltsCategories.find(
      (c) => c.pca_id === categoryId
    );
    return category?.pca_name ?? 'Sin categoría';
  }

  getAvailabilitySeverity(isAvailable: boolean): string {
    return isAvailable ? 'success' : 'danger';
  }

  getAvailabilityLabel(isAvailable: boolean): string {
    return isAvailable ? 'Disponible' : 'No disponible';
  }
}
